import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, InputLabel, Stack, Divider } from "@mui/material";
import React, { useState } from "react";

import { Modal } from "new-components/modals/Modal";
import { Typography } from "new-components/typography/Typography";
import { DEFAULT_CONFIDENCE_THRESHOLD } from "types/detectors";


export function ConfidenceSliderHeader() {
  const [infoModalIsOpen, setinfoModalIsOpen] = useState(false);
  const handleOpenInfoModal = () => setinfoModalIsOpen(true);
  const handleCloseInfoModal = () => setinfoModalIsOpen(false);
  return (
    <Box id="confidence-slider-header" data-testid="confidence-slider-header">
      <Stack direction="row" spacing={0.5} alignItems="center">
        <InputLabel className="uppercase text-sm text-neutral-700 font-bold">
          Confidence Threshold:
        </InputLabel>
        <IconButton aria-label="info" onClick={handleOpenInfoModal} sx={{ padding: 0 }}>
          <InfoIcon className="text-black" />
        </IconButton>
      </Stack>

      <Modal
        title="Confidence Threshold"
        icon={<InfoIcon sx={{ color: "white" }} />}
        size="small"
        titleAlignment="left"
        open={infoModalIsOpen}
        onClose={handleCloseInfoModal}
        onConfirmation={handleCloseInfoModal}
        body={[
          <Stack divider={<Divider />} gap="10px">
            <Typography key="confidence-slider-modal-text1" align="center" className="text-neutral-darkest">
              The confidence threshold is the level at which you want to trust the model&apos;s answers. Any answer with
              confidence below the threshold will be escalated to human review.
            </Typography>

            <Typography key="confidence-slider-modal-text2" align="center" className="text-neutral-darkest">
              If your application requires a human-verified answer for every query, set this to 1.0. If your application
              can handle an occasional error, a lower setting could work well. For average use, we recommend starting
              with a threshold of {DEFAULT_CONFIDENCE_THRESHOLD} and making adjustments as needed.
            </Typography>
          </Stack>
        ]}
      />
    </Box>
  );
}
